import { create } from "zustand";
import { persist } from "zustand/middleware";

import { createLegacyStorage, syncAcrossTabs } from "./legacyStorage";

const KEYS = ["error"];

/**
 * Global error bus consumed by ErrorModal. Persisted at the legacy "error"
 * key so an unhandled error survives a refresh and is visible across windows,
 * as it was under store.js.
 */
const useErrorStore = create(
  persist(
    set => ({
      error: undefined,
      setError: (message, items = []) =>
        set(s => ({
          error: {
            ...(s.error || {}),
            header: "Action Failed",
            message,
            items,
          },
        })),
      addForbiddenItem: item =>
        set(s => {
          const items = s.error?.items || [];
          return {
            error: {
              ...(s.error || {}),
              header: "Action Failed",
              message:
                "Your user role does not have permissions for that action",
              items: items.includes(item) ? items : [...items, item],
            },
          };
        }),
      clearError: () => set({ error: undefined }),
    }),
    { name: "error", storage: createLegacyStorage(KEYS) }
  )
);

syncAcrossTabs(useErrorStore, KEYS);

export default useErrorStore;
